import { OrdersViewTabs } from "types";

export enum OrderStatus {
  Canceled = 'canceled',
  Rejected = 'rejected',
  NotFilled = 'not_filled',
  PartiallyFilled = 'partially_filled',
  CompletelyFilled = 'completely_filled',
  Error = 'error',
  Reclaimed = 'reclaimed',
  PendingSettlement = 'pending_settlement',
  PendingReview = 'pending_review',
}

export enum OrderState {
  New = 'new',
  End = 'end',
  Settlement = 'settlement',
}

export enum OrderType {
  Limit = 'limit',
  Market = 'market',
}

export enum OrderSide {
  Sell = 'sell',
  Buy = 'buy',
}

export type OrderT = {
  id: string;
  user_id: string;
  user_address: string;
  side: string;
  instrument_id: string;
  type: string;
  price: number;
  quantity: number;
  escrow_address: string;
  escrow_id: number;
  deposit_amount: number | null;
  status: OrderStatus;
  error_message: string | null;
  state: string;
  created_at: string;
  updated_at: string;
  base_currency?: { precision: number };
  base_currency_id?: string;
  quote_currency?: { precision: number };
  quote_currency_id?: string;
};

export type OrderStatusesT = {
  [key: string]: string;
};

export type MarketTabT = {
  name: string;
  value: OrderType;
};

export type OrdersTabT = {
  name: string;
  value: OrdersViewTabs;
};